import useCopyToClipboard from "@/app/hooks/useCopyToClipboard";
import { ClipboardDocumentCheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Tooltip } from "react-tooltip";
import { IClipboardComponentProps } from "../interface";

const ClipboardComponent: React.FC<IClipboardComponentProps> = ({
  copyId,
  text,
  tooltipText,
  className,
  render,
  onCopyText,
}) => {
  const [isCopied, copyText] = useCopyToClipboard();

  return (
    <>
      <span
        data-tooltip-id={`copy-clipboard-id:${copyId}`}
        data-tooltip-content={`${tooltipText ? tooltipText : "Copy content"}`}
        onClick={(e) => {
          e.preventDefault();
          e.bubbles = false;
          copyText(text);
          if (onCopyText) {
            onCopyText();
          }
        }}
        className={clsx("inline cursor-pointer whitespace-nowrap", className && className !== "" ? className : "")}
      >
        {!render ? (
          isCopied ? (
            <ClipboardDocumentCheckIcon className="w-3 h-3 text-green-500" />
          ) : (
            <ClipboardDocumentIcon className="w-3 h-3 text-blue-500" />
          )
        ) : (
          render
        )}
      </span>
      <Tooltip place={"bottom"} style={{ fontSize: "10px" }} id={`copy-clipboard-id:${copyId}`} />
    </>
  );
};

export default ClipboardComponent;
